var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVodomerDobavyaneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "21.3,2.7 21.3,0 18.7,0 18.7,2.7 16,2.7 16,5.3 18.7,5.3 18.7,8 21.3,8 21.3,5.3 24,5.3 24,2.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,18.7c-0.1,0-0.2,0-0.2,0C3.9,18.7,4,18.7,4,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,18.7c0,0,0.1,0,0.1,0C20.1,18.7,20,18.7,20,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.7,13.3h-1.3c0,0-0.7,0-1.3,0C18.8,10.6,16,8,12,8c-3.9,0-6.8,2.7-8,5.3c0,0-0.5,0,0,0H1.3V12H0v8h1.3v-1.3 H4c1.2,2.6,4,5.3,8,5.3c4.2,0,6.8-2.7,8-5.3h2.7V20H24v-8h-1.3V13.3z M11.9,21.4C9,21.4,6.6,19,6.6,16c0-3,2.3-5.4,5.2-5.4 s5.5,2.4,5.5,5.4C17.4,19,14.8,21.4,11.9,21.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.3,
    y: 13.3,
    className: "st0",
    width: 5.3,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.3,
    y: 17.3,
    className: "st0",
    width: 5.3,
    height: 1.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodomerDobavyaneIcon);
export default __webpack_public_path__ + "static/media/vodomer_dobavyane_icon.61d9e4c9.svg";
export { ForwardRef as ReactComponent };